import React from "react";
import { Link, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@material-ui/core";
import {
  Description,
  DirectionsBoat,
  Inbox,
  ExpandLess,
  ExpandMore,
  Person,
  Star,
} from "@material-ui/icons";
import "./SidebarContentAdmin.scss";
import auth from "../Auth";
import { compose } from "recompose";
import AddIcon from "@material-ui/icons/Add";
import StopIcon from "@material-ui/icons/Stop";

import PauseIcon from "@material-ui/icons/Pause";
import ClearIcon from "@material-ui/icons/Clear";
import CheckIcon from "@material-ui/icons/Check";

const styles = {
  root: {
    padding: "2px",
  },
  sidebar: {
    width: 256,
    height: "100%",
  },
  sidebarLink: {
    display: "block",
    padding: "16px 0px",
    color: "#757575",
    textDecoration: "none",
  },
  divider: {
    margin: "8px 0",
    height: 1,
    backgroundColor: "#757575",
  },
  content: {
    padding: "4px",
    height: "100%",
    backgroundColor: "white",
  },
};

function ListItemLink(props) {
  const { icon, primary, to } = props;
  const style = {
    padding: "2px",
  };
  return (
    <div>
      {auth.isAuthenticated() ? (
        <ListItem button component={Link} to={to} style={style}>
          <ListItemIcon className="navItemIcon">{icon}</ListItemIcon>
          <ListItemText className="navLinks" primary={primary} />
        </ListItem>
      ) : (
        ""
      )}
    </div>
  );
}

ListItemLink.propTypes = {
  icon: PropTypes.node.isRequired,
  primary: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  nested: PropTypes.string,
};

class ListItemLinkNestedFormsDatasheets extends React.Component {
  renderLink = (itemProps) => <Link to={this.props.to} {...itemProps} />;

  state = {
    open: false,
    childOpen: false,
  };

  handleClick = () => {
    // Toggle dropdown
    this.setState((state) => ({
      open: !state.open,
      childOpen: !state.open ? true : false,
    }));
  };

  handleExpandClick = (e) => {
    e.stopPropagation(); // Prevent the main click handler from firing
    this.setState((state) => ({
      open: !state.open,
      childOpen: !state.open ? true : false,
    }));
  };

  handleTextClick = (e) => {
    e.stopPropagation(); // Prevent the main click handler from firing
    window.location.href = "/pre-approval-claim?type=new";
  };
  handleClickChild = () => {
    this.setState((state) => ({ childOpen: !state.childOpen }));
  };

  render() {
    const { icon, primary, history } = this.props;
    // const userRole = auth.getRole();
    const style = {
      padding: "2px",
    };

    return (
      <div className="custom-dropbox">
        {" "}
        {/* className={`${this.state.open ? "drop-menu-active" : ""}`} */}
        <ListItem button onClick={this.handleClick} style={style}>
          <ListItemIcon className="navItemIcon">{icon}</ListItemIcon>
          <ListItemText
            className="navLinks"
            primary={primary}
            onClick={this.handleTextClick}
            style={{ cursor: "pointer" }}
          />
          <div className="expand-icon" onClick={this.handleExpandClick}>
            {this.state.open ? <ExpandLess /> : <ExpandMore />}
          </div>
        </ListItem>
        <Collapse in={this.state.open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* <ListItem
              button // Add the button attribute to make the ListItem clickable
              onClick={this.handleClickChild}
            >
              <Link
                to="/forms-co-op-pre-approval-claim-forms"
                className="navLinks"
              >
                <ListItemText primary="CO-OP Pre-Approval Claim Forms" />
              </Link>
            </ListItem> */}
            <Collapse in={this.state.childOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button>
                  <Link to={"/pre-approval-claim?type=new"}>
                    <AddIcon />
                    <ListItemText primary="Submitted Request" />
                  </Link>
                </ListItem>
                <ListItem button>
                  <Link to="/pre-approval-claim?type=pending">
                    <PauseIcon />
                    <ListItemText primary="Pending" />
                  </Link>
                </ListItem>
                {/* {userRole !== "sales" && ( */}
                  <ListItem button>
                    <Link to="/pre-approval-claim?type=denied">
                      <ClearIcon />
                      <ListItemText primary="Denied" />
                    </Link>
                  </ListItem>
                {/* )} */}

                {/* {userRole !== "sales" && ( */}
                  <ListItem button>
                    <Link to="/pre-approval-claim?type=approved">
                      <CheckIcon />
                      <ListItemText primary="Approved" />
                    </Link>
                  </ListItem>
                {/* )} */}
              </List>
            </Collapse>
            {/* <ListItem button disabled>
              <Link to="/forms-msrp-datasheets" className="navLinks">
                <ListItemText primary="MSRP Data Sheets" />
              </Link>
            </ListItem> */}
          </List>
        </Collapse>
      </div>
    );
  }
}

ListItemLinkNestedFormsDatasheets.propTypes = {
  icon: PropTypes.node.isRequired,
  state: PropTypes.object,
  primary: PropTypes.node.isRequired,
};
function ComponentProperty(props) {
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const { classes } = props;

  return (
    <div className={classes.root} style={styles.content}>
      <List component="nav" className={props.root}>
        <ListItemLink
          to="/dashboard"
          primary="Dashboard"
          className="navItemIcon"
          icon={<Inbox />}
        />
        <div className="outside_rep_portal">
          <ListItem onClick={handleClick}>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText primary="OUTSIDE REP PORTAL" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button component={Link} to="/my-dealers" sx={{ pl: 4 }}>
                <ListItemIcon>
                  <StopIcon style={{ height: "10px" }} />
                </ListItemIcon>
                <ListItemText primary="MY DEALERS" />
              </ListItem>

              {/* <List>
                <ListItem button onClick={handleClick}>
                  <ListItemText primary="Main Item" />
                  {open ? <ExpandLess /> : <ExpandMore />}
                </ListItem> */}
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  style={{ marginLeft: "40px" }}
                >
                  <ListItem
                    button
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/dealer-request"
                  >
                    <ListItemIcon>
                      <AddIcon style={{ height: "15px" }} />
                    </ListItemIcon>
                    <ListItemText primary="NEW DEALER REQUEST" />
                  </ListItem>
                </List>
              </Collapse>
              {/* </List> */}
            </List>
            {/* <List component="div" disablePadding>
              <ListItem sx={{ pl: 4 }} button component={Link} to="/inventory">
                <ListItemIcon>
                  <StopIcon style={{ height: "10px" }} />
                </ListItemIcon>
                <ListItemText primary="DEALER INVENTORY" />
              </ListItem>
            </List> */}
            {/* <List component="div" disablePadding>
              <ListItem
                button
                component={Link}
                to="/dealer-dvr-report"
                sx={{ pl: 4 }}
              >
                <ListItemIcon>
                  <StopIcon style={{ height: "10px" }} />
                </ListItemIcon>
                <ListItemText primary="DEALER DVR REPORT" />
              </ListItem>
            </List> */}
          </Collapse>
        </div>

        <ListItemLink
          to="/sales-warranty-registrations"
          primary="Warranty Registration"
          className="navItemIcon"
          icon={<Description />}
        />
        <ListItemLink
          to="/sales-boat-shows"
          primary="Boat Shows"
          className="navItemIcon"
          icon={<DirectionsBoat />}
        />

        <ListItemLink
          to="/sales-csi"
          primary="Sales CSI"
          icon={<Star />}
          className="navItemIcon"
          // permission="sales:SALES_CSI"
        />

        <ListItemLinkNestedFormsDatasheets
          primary="Forms & Data Sheets"
          className="navItemIcon"
          icon={<Description />}
          permission="sales:SALES_ALL"
        />
      </List>
    </div>
  );
}

ComponentProperty.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withRouter, withStyles(styles))(ComponentProperty);
